module.exports = __webpack_public_path__ + "static/media/agenda-title.aaab8fae.svg";